import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Check } from "@air/next-icons";
import { memo } from "react";
import { BOUNDING_BOX_AVATAR_WIDTH, BoundingBoxAvatar } from "~/components/BoundingBox/components/BoundingBoxAvatar";
import { getHorizontalOpposite } from "~/components/BoundingBox/types";
import { ANNOTATION_AVATAR_BUTTON } from "~/constants/testIDs";
export const AnnotationAvatarButton = /*#__PURE__*/ memo((param)=>{
    let { discussion, position, onAvatarClick } = param;
    var _discussion_comments_data_;
    return /*#__PURE__*/ _jsxs("button", {
        "data-testid": ANNOTATION_AVATAR_BUTTON,
        onClick: (event)=>{
            event.stopPropagation();
            onAvatarClick(discussion);
        },
        children: [
            /*#__PURE__*/ _jsx(BoundingBoxAvatar, {
                account: (_discussion_comments_data_ = discussion.comments.data[0]) === null || _discussion_comments_data_ === void 0 ? void 0 : _discussion_comments_data_.account,
                className: discussion.resolved ? "light:bg-grey-5 dark:bg-grey-11" : "light:bg-grey-3 dark:bg-grey-12",
                direction: getHorizontalOpposite(position)
            }),
            discussion.resolved && /*#__PURE__*/ _jsx("div", {
                className: "absolute flex items-center justify-center bg-black/60",
                style: {
                    borderRadius: BOUNDING_BOX_AVATAR_WIDTH,
                    height: BOUNDING_BOX_AVATAR_WIDTH,
                    width: BOUNDING_BOX_AVATAR_WIDTH
                },
                children: /*#__PURE__*/ _jsx(Check, {
                    className: "size-4 text-white"
                })
            })
        ]
    });
});
AnnotationAvatarButton.displayName = "AnnotationAvatarButton";
